export const sort = [
  { label: "ID", name: "id", style: { width: "25%" } },
  { label: "Nazwa", name: "name", style: { width: "25%" } },
];

export const filters = [
  {
    type: "input",
    name: "id",
    sort_id: "id",
    search_type: "matches",
  },
  {
    type: "input",
    name: "name",
    sort_id: "name",
    search_type: "matches",
  },
];
